import { render } from "./list_1.vue?vue&type=template&id=66ccf7f4"
import script from "./list_1.vue?vue&type=script&lang=js"
export * from "./list_1.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/oralhealthmap.uz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__